import React from 'react'

import config from '../config.js'

import axios from 'axios'

import { MuiThemeProvider } from '@material-ui/core/styles'

import { Button, TextField } from '@material-ui/core/'

import Chat from './Chat'
import LoadingIcon from './LoadingIcon'
import Participant from './Participant'
import {Message, canPostMessageToMobile, postMessageToMobile} from "../Helpers/clientCommunication";

class Conversation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      message: ''
    }
  }

  isPolling = true

  chatsEnd = React.createRef()

  // Scroll to bottom function found here: https://stackoverflow.com/a/52266212
  // One important difference is that we didn't choose to use scrollToBottom in componentDidUpdate because then anytime anything on the page changed,
  // the user would find themselves at the bottom of the page, whether they wanted to or not (e.g., they loaded more chats at the top)
  scrollToBottom = () => {
    this.chatsEnd.current.scrollIntoView({ behavior: 'smooth' })
  }

  componentDidMount() {
    const _this = this

    // We use a timeout so the user can get their bearings before things happen
    // and because otherwise the page will occasionally load too slowly to properly fire these functions
    setTimeout(
      function() {
        _this.scrollToBottom()
        _this.markSeen(0)
      },
      2500,
      _this
    )

    // We need to keep the conversation on the page up-to-date so that messages from the other member(s) of the conversation appear without too much delay and without reloading
    // The ideal way to do this is with push notifications, but it will be some time before the old embedded browser is replaced (not done as of 4/15/2019) and enough people have downloaded it
    // In the meantime, we're going to set up a polling function to ping the server
    // Call "getChats" every 15 seconds with the timestamp of the most recent conversation
    setTimeout(
      function() {
        _this.intervalId = setInterval(
          function() {
            if (_this.props !== undefined) {
              _this.props.getChats(
                _this.props.conversation.conversationId,
                _this.props.conversation.chats[
                  _this.props.conversation.chats.length - 1
                ].dateCreated,
                _this.isPolling
              )
            }
          },
          15000,
          _this
        )
      },
      1500,
      _this
    )
  }

  componentWillUnmount() {
    //console.log('Unmounting and clearing interval')
    clearInterval(this.intervalId)
  }

  getParticipant = (conversation, userId) => {
    let participant = undefined

    if (conversation.participants) {
      participant = conversation.participants.filter(
        item => item.accountId === userId
      )

      if (participant.length > 0) {
        // We need to index into the returned array
        // This also fixes the weird situation where there might be more than one participants with the same id
        participant = participant[0]
      } else participant = null
    } else {
      participant = null
    }

    return participant
  }

  getParticipantNames = (participants, aid) => {
    let participantNames = participants.filter(function(participant) {
      return participant.accountId !== aid
    })

    participantNames = participantNames.map(function(participant) {
      return participant.displayName
    })

    participantNames = participantNames.join(', ')

    return participantNames
  }

  getFriendName = (friends, fid) => {
    let friendName = friends.filter(function(friend) {
      return friend.accountId === fid
    })

    return friendName[0].name
  }

  loadMore = () => {
    const conversation = this.props.conversation

    this.props.getChats(
      conversation.conversationId,
      conversation.chats[0].dateCreated
    )

    // After fetching more chats, we need to re-mark the chats as seen
    this.markSeen(0)
  }

  refreshChats = () => {
    const conversation = this.props.conversation

    this.props.getChats(
      conversation.conversationId,
      conversation.chats[conversation.chats.length - 1].dateCreated,
      this.isPolling
    )

    // After fetching more chats, we need to re-mark the chats as seen
    this.markSeen(0)
  }

  messageFormSubmit = e => {
    e.preventDefault()

    if (this.props.conversation !== undefined) {
      let conversationId = null

      if (this.state.message !== '') {
        if (this.props.conversation !== null) {
          conversationId = this.props.conversation.conversationId
          this.props.addChat(this.props.aid, conversationId, this.state.message)
        } else {
          if (this.props.friendId !== null) {
            this.props.addConversation(
              this.props.aid,
              [this.props.friendId],
              this.state.message
            )
          } else {
            // We shouldn't really ever get here...
            console.log('There was no existing conversation or friendId')
          }
        }

        // In an ideal world, we would only clear the text area if the chat message was sent successfully,
        // but asynchronous calls and tricky state management mean we're doing it this way instead.
        this.setState({
          message: ''
        })

        // When the thread gets long, it's helpful to help the user get down to where the new action is and to see the form.
        this.scrollToBottom()
      }
    } else {
      // Don't do anything, we're still trying to see if there's a conversation or not
    }
  }

  messageFormChangeHandler = e => {
    const target = e.target
    const value = target.value
    const name = target.name

    this.setState({
      [name]: value
    })
  }

  messageFormSubmitWatcher = e => {
    if (e.key === 'Enter') {
      this.messageFormSubmit(e)
    }
  }

  // Now that we have the chats, we're going to go through and mark the ones that were "new" as "seen"
  markSeen = i => {
    const classInstance = this

    let hasBeenSeen = false
    let seenBy = undefined

    const aid = this.props.aid
    const conversation = this.props.conversation
    if (conversation) {
      const chats = conversation.chats
      if (chats && chats.length > 0) {
        const chat = chats[i]
        if (chat.seenBy !== undefined) {
          seenBy = chat.seenBy
          seenBy = seenBy.filter(item => item === aid)
        }

        if (seenBy === undefined || seenBy.length === 0) {
          // This chat wasn't seen by the user until this component loaded. It has been seen now, so
          // Make the API call to record the seeing on the server
          let data = JSON.stringify({
            accountId: aid,
            conversationId: conversation.conversationId,
            chatId: chat.chatId
          })

          axios
            .post(config.apiServer + '/api/v3/chat/seen', data, {
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then(
              response => {
                const json = response.data

                if (json.key === 'OK') {
                  // When the call returns success, we also need to update the "seen" array in our data or we will get strange behavior later
                  this.props.updateChatSeen(
                    aid,
                    conversation.conversationId,
                    chat.chatId
                  )
                } else {
                  // We currently don't do anything if the return isn't what we want
                }

                // Wait 1 second and then launch the function for the next item
                if (i < chats.length - 1) {
                  setTimeout(
                    function() {
                      classInstance.markSeen(i + 1)
                    },
                    1000,
                    classInstance
                  )
                } else {
                  // This was the latest unseen chat, tell the mobile apps the conversation has been read
                  const device = this.props.device
                  const version = this.props.version
                  if (canPostMessageToMobile(device, version)) {
                    const message = new Message(Message.ACTION_DID_READ_CHAT_CONVERSATION, {})
                    postMessageToMobile(device, version, message)
                  } else {
                    console.log("Conversation.markSeen: Messaging system not implemented, can't send message to mobile")
                  }
                }
              },
              error => {
                console.log(error)
              }
            )
        } else if (seenBy.length > 0) {
          // No API call necessary
          // Launch the function for the next item immediately
          if (i < chats.length - 1) {
            classInstance.markSeen(i + 1)
          }
        }
      }
    }
  }

  render() {
    let participantNames = 'your friends'
    let chatItems = ''
    let chats = ''

    if (this.props.conversation !== undefined) {
      if (this.props.conversation !== null) {
        if (this.props.conversation.participants) {
          if (this.props.conversation.participants.length < 6) {
            participantNames = this.getParticipantNames(
              this.props.conversation.participants,
              this.props.aid
            )
          }
        }

        if (
          this.props.conversation.chats &&
          this.props.conversation.chats.length > 0
        ) {
          chatItems = this.props.conversation.chats.map(item => {
            let sender = ''
            let participant = this.getParticipant(
              this.props.conversation,
              item.accountId
            )

            if (participant) {
              sender = (
                <Participant aid={this.props.aid} participant={participant} />
              )
            }

            return (
              <Chat
                key={item.chatId}
                aid={this.props.aid}
                linkToConversation={false}
                sender={sender}
                chat={item}
              />
            )
          })

          chats = (
            <MuiThemeProvider theme={config.theme}>
              <h2 className="conversation__header text-center">
                Conversation with&nbsp;{participantNames}
              </h2>
              <div className="chats">
                <div className="text-center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      this.loadMore()
                    }}
                    disabled={this.props.conversation.moreChats ? false : true}
                  >
                    <span className="material-icons md-24">arrow_upward</span>
                    Load Older Messages
                  </Button>
                </div>
                <ul className="conversation">{chatItems}</ul>
                {/*<div className="text-center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                      this.refreshChats()
                    }}
                  >
                    Check for New Messages
                  </Button>
                </div>*/}
              </div>
              <form
                id="message-form"
                className="text-center"
                style={{ paddingBottom: '3em' }}
                method="post"
                onSubmit={e => {
                  this.messageFormSubmit(e)
                }}
              >
                <TextField
                  id="message"
                  name="message"
                  value={this.state.message}
                  multiline
                  rows="3"
                  label={'Type a message to ' + participantNames}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  onChange={this.messageFormChangeHandler}
                  onKeyPress={this.messageFormSubmitWatcher}
                />
                <p>
                  <Button variant="contained" color="primary" type="submit">
                    Send
                  </Button>
                </p>
              </form>
            </MuiThemeProvider>
          )
        } else {
          // There aren't any chats with this conversation yet
          let friendName = ''

          if (this.props.friends) {
            friendName = this.getFriendName(
              this.props.friends,
              this.props.friendId
            )
          }

          chats = (
            <MuiThemeProvider theme={config.theme}>
              <h2 className="conversation__header text-center">
                Start a Conversation with {friendName}
              </h2>
              <form
                id="message-form"
                className="text-center"
                style={{ paddingBottom: '3em' }}
                method="post"
                onSubmit={e => {
                  this.messageFormSubmit(e)
                }}
              >
                <TextField
                  id="message"
                  name="message"
                  value={this.state.message}
                  multiline
                  rows="3"
                  label={'Type a message to ' + participantNames}
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  onChange={this.messageFormChangeHandler}
                  onKeyPress={this.messageFormSubmitWatcher}
                />
                <p>
                  <Button variant="contained" color="primary" type="submit">
                    Send
                  </Button>
                </p>
              </form>
            </MuiThemeProvider>
          )
        }
      } else {
        // There isn't a conversation yet
        let friendName = ''

        if (this.props.friends) {
          friendName = this.getFriendName(
            this.props.friends,
            this.props.friendId
          )
        }

        chats = (
          <MuiThemeProvider theme={config.theme}>
            <h2 className="conversation__header text-center">
              Start a Conversation with {friendName}
            </h2>
            <form
              id="message-form"
              className="text-center"
              style={{ paddingBottom: '3em' }}
              method="post"
              onSubmit={e => {
                this.messageFormSubmit(e)
              }}
            >
              <TextField
                id="message"
                name="message"
                value={this.state.message}
                multiline
                rows="3"
                label={'Type a message to ' + participantNames}
                margin="dense"
                variant="outlined"
                fullWidth
                onChange={this.messageFormChangeHandler}
                onKeyPress={this.messageFormSubmitWatcher}
              />
              <p>
                <Button variant="contained" color="primary" type="submit">
                  Send
                </Button>
              </p>
            </form>
          </MuiThemeProvider>
        )
      }
    } else {
      // What to do while data is loading
      chats = (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <LoadingIcon />
        </div>
      )
    }

    return (
      <div className="conversation-container">
        {chats}
        <div ref={this.chatsEnd} />
      </div>
    )
  }
}

export default Conversation



// WEBPACK FOOTER //
// ./src/Components/Conversation.js